import React, {useState} from "react";
import {TaxModelsRestControllerApiFactory, TaxSubmissionList, TaxSubmissionRestControllerApiFactory} from "arteco-api-client-ts";
import {fmtAmt} from "../../../../components/utils/numbers";
import {dateToString} from "../../../../components/utils/dates";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {
    Alert,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {FormButtonProps} from "../../../../components/form/form_inputs/form_button";
import {SoftChip} from "../../../../components/kit";
import {numSx, TAX_MODEL_LABEL, taxStatus} from "./labels";
import {Modelo200Dialog, Modelo202Dialog} from "./corporate_tax_dialogs";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import {
    exportModelo111Xls,
    exportModelo115Xls,
    exportModelo180Xls,
    exportModelo190Xls,
    exportModelo303Xls,
    exportModelo347Xls,
    exportModelo349Xls,
    exportModelo390Xls,
} from "../../../../components/utils/xlsExport";

export const TaxSubmissionListPage = () => {
    const apiManager = useApiManager();
    const taxCtrl = apiManager.factory(TaxModelsRestControllerApiFactory);
    const currentYear = new Date().getFullYear();

    const currentQuarter = Math.ceil((new Date().getMonth() + 1) / 3);

    const [trigger, setTrigger] = useState(0);
    const [modelo190, setModelo190] = useState<any>(null);
    const [modelo111, setModelo111] = useState<any>(null);
    const [loadingM111, setLoadingM111] = useState(false);
    const [m200Open, setM200Open] = useState(false);
    const [m202Open, setM202Open] = useState(false);
    const [modelo303, setModelo303] = useState<any>(null);
    const [modelo390, setModelo390] = useState<any>(null);
    const [modelo347, setModelo347] = useState<any>(null);
    const [modelo349, setModelo349] = useState<any>(null);
    const [m349Year, setM349Year] = useState(currentYear);
    const [m349Quarter, setM349Quarter] = useState(currentQuarter > 1 ? currentQuarter - 1 : 4);
    const [modelo115, setModelo115] = useState<any>(null);
    const [m115Quarter, setM115Quarter] = useState(currentQuarter > 1 ? currentQuarter - 1 : 4);
    const [modelo180, setModelo180] = useState<any>(null);
    const [modelo130, setModelo130] = useState<any>(null);
    const [m130Quarter, setM130Quarter] = useState<number>(currentQuarter || 1);
    const [loadingM130, setLoadingM130] = useState(false);
    const [loadingM190, setLoadingM190] = useState(false);
    const [loadingM303, setLoadingM303] = useState(false);
    const [loadingM390, setLoadingM390] = useState(false);
    const [loadingM347, setLoadingM347] = useState(false);
    const [loadingM349, setLoadingM349] = useState(false);
    const [loadingM115, setLoadingM115] = useState(false);
    const [loadingM180, setLoadingM180] = useState(false);

    const handleModelo190 = (year: number) => {
        setLoadingM190(true);
        apiManager.execute(taxCtrl.modelo190(year))
            .then(data => setModelo190(data))
            .catch(() => {})
            .finally(() => setLoadingM190(false));
    };

    const handleModelo111 = (year: number, quarter: number) => {
        setLoadingM111(true);
        apiManager.execute(taxCtrl.modelo111(year, quarter))
            .then(data => setModelo111(data))
            .catch(() => {})
            .finally(() => setLoadingM111(false));
    };

    const handleModelo390 = (year: number) => {
        setLoadingM390(true);
        apiManager.execute(taxCtrl.modelo390(year))
            .then(data => setModelo390(data))
            .catch(() => {})
            .finally(() => setLoadingM390(false));
    };

    const handleModelo347 = (year: number) => {
        setLoadingM347(true);
        apiManager.execute(taxCtrl.modelo347(year))
            .then(data => setModelo347(data))
            .catch(() => {})
            .finally(() => setLoadingM347(false));
    };

    const handleModelo130 = (year: number, quarter: number) => {
        setLoadingM130(true);
        apiManager.execute(taxCtrl.getModelo130(year, quarter))
            .then(data => setModelo130(data))
            .catch(() => {})
            .finally(() => setLoadingM130(false));
    };

    const m303DefaultQuarter = currentQuarter > 1 ? currentQuarter - 1 : 4;
    const m303DefaultYear = currentQuarter > 1 ? currentYear : currentYear - 1;

    const handleModelo303 = (year: number, quarter: number) => {
        setLoadingM303(true);
        apiManager.execute(taxCtrl.getModelo303(year, quarter))
            .then(data => setModelo303(data))
            .catch(() => {})
            .finally(() => setLoadingM303(false));
    };

    const handleModelo349 = (year: number, quarter: number) => {
        setLoadingM349(true);
        apiManager.execute(taxCtrl.getModelo349(year, quarter))
            .then(data => setModelo349(data))
            .catch(() => {})
            .finally(() => setLoadingM349(false));
    };

    const handleModelo115 = (year: number, quarter: number) => {
        setLoadingM115(true);
        apiManager.execute(taxCtrl.getModelo115(year, quarter))
            .then(data => setModelo115(data))
            .catch(() => {})
            .finally(() => setLoadingM115(false));
    };

    const handleModelo180 = (year: number) => {
        setLoadingM180(true);
        apiManager.execute(taxCtrl.getModelo180(year))
            .then(data => setModelo180(data))
            .catch(() => {})
            .finally(() => setLoadingM180(false));
    };

    const listConfig: AppListConfig<TaxSubmissionList> = {
        title: "Modelos fiscales",
        onClick: "/app/admin/accounting/tax-submission",
        headers: [
            {title: "Modelo"},
            {title: "Año"},
            {title: "Período"},
            {title: "Estado"},
            {title: "Base", align: "right"},
            {title: "Cuota", align: "right"},
            {title: "Referencia (NRC)"},
            {title: "Presentación"},
        ],
        actions: [
            {
                label: loadingM111 ? "Calculando..." : `M111 Retenciones ${m303DefaultYear} T${m303DefaultQuarter}`,
                action: () => handleModelo111(m303DefaultYear, m303DefaultQuarter),
                group: "IRPF",
            } as FormButtonProps,
            {
                label: loadingM190 ? "Calculando..." : `M190 IRPF anual ${currentYear - 1}`,
                action: () => handleModelo190(currentYear - 1),
            } as FormButtonProps,
            {
                label: loadingM130 ? "Calculando..." : `M130 IRPF autónomos T${m130Quarter} ${currentYear}`,
                action: () => handleModelo130(currentYear, m130Quarter),
                group: "IRPF",
            } as FormButtonProps,
            {
                label: loadingM347 ? "Calculando..." : `Ver M347 Terceros ${currentYear - 1}`,
                action: () => handleModelo347(currentYear - 1),
            } as FormButtonProps,
            {
                label: `M202 Pagos fraccionados ${currentYear}`,
                action: () => setM202Open(true),
                group: "IS",
            } as FormButtonProps,
            {
                label: `M200 IS Anual ${currentYear - 1}`,
                action: () => setM200Open(true),
                group: "IS",
            } as FormButtonProps,
            {
                label: loadingM303 ? "Calculando..." : `M303 IVA ${m303DefaultYear} T${m303DefaultQuarter}`,
                action: () => handleModelo303(m303DefaultYear, m303DefaultQuarter),
                group: "IVA",
            } as FormButtonProps,
            {
                label: loadingM390 ? "Calculando..." : `M390 IVA anual ${currentYear - 1}`,
                action: () => handleModelo390(currentYear - 1),
                group: "IVA",
            } as FormButtonProps,
            {
                label: loadingM349 ? "Calculando..." : `M349 Intracomunitario ${m349Year} T${m349Quarter}`,
                action: () => handleModelo349(m349Year, m349Quarter),
                group: "IVA",
            } as FormButtonProps,
            {
                label: loadingM115 ? "Calculando..." : `M115 Alquiler ${currentYear} T${m115Quarter}`,
                action: () => handleModelo115(currentYear, m115Quarter),
                group: "Alquileres",
            } as FormButtonProps,
            {
                label: loadingM180 ? "Calculando..." : `M180 Alquiler anual ${currentYear - 1}`,
                action: () => handleModelo180(currentYear - 1),
                group: "Alquileres",
            } as FormButtonProps,
        ],
        decorator: (bean: TaxSubmissionList) => (
            <>
                <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}} sx={{fontWeight: 600}}>
                    {TAX_MODEL_LABEL[bean.modelType || ""] || bean.modelType}
                </TableCell>
                <TableCell sx={numSx}>{bean.year}</TableCell>
                <TableCell>{bean.period ?? "—"}</TableCell>
                <TableCell>
                    <SoftChip label={taxStatus(bean.status).label} tone={taxStatus(bean.status).tone}/>
                </TableCell>
                <TableCell align="right" sx={numSx}>{fmtAmt(bean.baseAmount)}</TableCell>
                <TableCell align="right" sx={{...numSx, fontWeight: 600}}>{fmtAmt(bean.taxAmount)}</TableCell>
                <TableCell sx={{...numSx, overflow: "hidden", textOverflow: "ellipsis"}}>{bean.reference ?? "—"}</TableCell>
                <TableCell sx={numSx}>{dateToString(bean.presentationDate) || "—"}</TableCell>
            </>
        ),
        toolbar: (
            <Box display="flex" alignItems="center" gap={1} mb={2}>
                <Typography variant="body2" color="text.secondary">Trimestre para el M130:</Typography>
                <Select
                    size="small"
                    value={m130Quarter}
                    onChange={e => setM130Quarter(Number(e.target.value))}
                    sx={{minWidth: 80, borderRadius: 2}}
                >
                    <MenuItem value={1}>T1</MenuItem>
                    <MenuItem value={2}>T2</MenuItem>
                    <MenuItem value={3}>T3</MenuItem>
                    <MenuItem value={4}>T4</MenuItem>
                </Select>
            </Box>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(TaxSubmissionRestControllerApiFactory);
            return ctrl.pageTaxSubmission(currentPage, size, undefined, undefined, undefined, undefined, term, showDismissed);
        },
    };

    return (
        <>
            <AppList config={listConfig} trigger={trigger}/>

            {/* Modelo 130 — Pago fraccionado IRPF autónomos */}
            <Dialog open={!!modelo130} onClose={() => setModelo130(null)} maxWidth="sm" fullWidth PaperProps={{sx: {borderRadius: 3}}}>
                <DialogTitle sx={{fontWeight: 700}}>
                    Modelo 130 — Pago fraccionado IRPF T{modelo130?.quarter} {modelo130?.year}
                </DialogTitle>
                <DialogContent>
                    <Table size="small">
                        <TableBody>
                            <TableRow>
                                <TableCell><strong>Ingresos acumulados (grupo 7)</strong></TableCell>
                                <TableCell align="right">{fmtAmt(modelo130?.revenue)} €</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Gastos acumulados (grupo 6)</strong></TableCell>
                                <TableCell align="right">{fmtAmt(modelo130?.expenses)} €</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Rendimiento neto</strong></TableCell>
                                <TableCell align="right">
                                    <strong style={{color: (modelo130?.netIncome ?? 0) < 0 ? "orange" : "inherit"}}>
                                        {fmtAmt(modelo130?.netIncome)} €
                                    </strong>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Tipo ({modelo130?.rate != null ? (modelo130.rate * 100).toFixed(0) : "20"}%)</TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Cuota bruta (rendimiento × 20%)</TableCell>
                                <TableCell align="right">{fmtAmt(modelo130?.grossTax)} €</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Pagos fraccionados anteriores (M130)</TableCell>
                                <TableCell align="right">- {fmtAmt(modelo130?.previousPayments)} €</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <strong>{(modelo130?.netTax ?? 0) > 0 ? "Cuota a ingresar" : "Resultado (sin pago)"}</strong>
                                </TableCell>
                                <TableCell align="right">
                                    <strong style={{color: (modelo130?.netTax ?? 0) > 0 ? "inherit" : "green"}}>
                                        {fmtAmt(modelo130?.netTax)} €
                                    </strong>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    <Box mt={2}>
                        <Typography variant="caption" color="text.secondary">
                            Este cálculo es informativo. El registro del pago se realiza manualmente creando un
                            TaxSubmission de tipo M130_IRPF_AUTONOMO con periodo T{modelo130?.quarter}.
                        </Typography>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* ── Modelo 303 — IVA Trimestral ──────────────────────────────────── */}
            <Dialog open={!!modelo303} onClose={() => setModelo303(null)} maxWidth="md" fullWidth PaperProps={{sx: {borderRadius: 3}}}>
                <DialogTitle sx={{fontWeight: 700}}>
                    Modelo 303 — IVA Trimestral {modelo303?.year} T{modelo303?.quarter}
                </DialogTitle>
                <DialogContent>
                    {/* IVA DEVENGADO */}
                    <Typography variant="subtitle1" sx={{mt: 1, mb: 0.5, fontWeight: "bold"}}>
                        IVA Devengado (repercutido)
                    </Typography>
                    <TableContainer sx={{overflowX: "auto"}}><Table size="small" sx={{minWidth: 520}}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Casilla</TableCell>
                                <TableCell>Concepto</TableCell>
                                <TableCell align="right">Base (€)</TableCell>
                                <TableCell align="right">Cuota (€)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>01 / 03</TableCell>
                                <TableCell>Régimen general al 4 %</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.base01)}</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.cuota03)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>04 / 06</TableCell>
                                <TableCell>Régimen general al 10 %</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.base04)}</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.cuota06)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>07 / 09</TableCell>
                                <TableCell>Régimen general al 21 %</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.base07)}</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.cuota09)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>10 / 11</TableCell>
                                <TableCell>Adquisiciones intracomunitarias</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.base10)}</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.cuota11)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>12 / 13</TableCell>
                                <TableCell>Otras con inversión del sujeto pasivo</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.base12)}</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.cuota13)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>14 / 15</TableCell>
                                <TableCell>Modificación bases y cuotas (rectificativas)</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.base14)}</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.cuota15)}</TableCell>
                            </TableRow>
                            <TableRow sx={{backgroundColor: "action.hover"}}>
                                <TableCell><strong>27</strong></TableCell>
                                <TableCell><strong>Total cuota devengada</strong></TableCell>
                                <TableCell/>
                                <TableCell align="right"><strong>{fmtAmt(modelo303?.total27)}</strong></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table></TableContainer>

                    {/* IVA DEDUCIBLE */}
                    <Typography variant="subtitle1" sx={{mt: 2, mb: 0.5, fontWeight: "bold"}}>
                        IVA Deducible (soportado)
                    </Typography>
                    <TableContainer sx={{overflowX: "auto"}}><Table size="small" sx={{minWidth: 520}}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Casilla</TableCell>
                                <TableCell>Concepto</TableCell>
                                <TableCell align="right">Base (€)</TableCell>
                                <TableCell align="right">Cuota (€)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>28 / 29</TableCell>
                                <TableCell>Operaciones interiores corrientes</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.base28)}</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.cuota29)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>36 / 37</TableCell>
                                <TableCell>Adquisiciones intracomunitarias corrientes</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.base36)}</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.cuota37)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>40 / 41</TableCell>
                                <TableCell>Rectificación de deducciones</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.base40)}</TableCell>
                                <TableCell align="right">{fmtAmt(modelo303?.cuota41)}</TableCell>
                            </TableRow>
                            <TableRow sx={{backgroundColor: "action.hover"}}>
                                <TableCell><strong>45</strong></TableCell>
                                <TableCell><strong>Total a deducir</strong></TableCell>
                                <TableCell/>
                                <TableCell align="right"><strong>{fmtAmt(modelo303?.total45)}</strong></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table></TableContainer>

                    {(modelo303?.avisos?.length ?? 0) > 0 && (
                        <Alert severity="warning" sx={{mt: 2}}>
                            {modelo303.avisos.map((a: string, i: number) => <div key={i}>{a}</div>)}
                        </Alert>
                    )}

                    {/* RESULTADO */}
                    <Box mt={2} p={1.5} sx={{border: "1px solid", borderColor: "divider", borderRadius: 1}}>
                        <Typography variant="body1">
                            <strong>Casilla 46 — Resultado régimen general:</strong>{" "}
                            <strong style={{
                                fontSize: "1.1rem",
                                color: (modelo303?.resultado46 ?? 0) < 0 ? "green" : (modelo303?.resultado46 ?? 0) > 0 ? "#d32f2f" : "inherit",
                            }}>
                                {fmtAmt(modelo303?.resultado46)} €
                            </strong>
                            {" "}
                            <Typography component="span" variant="caption" color="text.secondary">
                                {(modelo303?.resultado46 ?? 0) > 0 ? "(a ingresar)" : (modelo303?.resultado46 ?? 0) < 0 ? "(a compensar / devolver)" : ""}
                            </Typography>
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions sx={{px: 3, pb: 2}}>
                    <Button size="small" variant="outlined" startIcon={<DownloadRoundedIcon/>}
                            onClick={() => exportModelo303Xls(modelo303)}>Descargar XLS</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={!!modelo111} onClose={() => setModelo111(null)} maxWidth="sm" fullWidth PaperProps={{sx: {borderRadius: 3}}}>
                <DialogTitle sx={{fontWeight: 700}}>
                    Modelo 111 — Retenciones {modelo111?.year} T{modelo111?.quarter}
                </DialogTitle>
                <DialogContent>
                    <Box sx={{overflowX: "auto"}}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Bloque</TableCell>
                                    <TableCell align="right">Perceptores</TableCell>
                                    <TableCell align="right">Percepciones</TableCell>
                                    <TableCell align="right">Retenciones</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>Trabajo, dinerario (01-03)</TableCell>
                                    <TableCell align="right" sx={numSx}>{modelo111?.perceptores01}</TableCell>
                                    <TableCell align="right" sx={numSx}>{fmtAmt(modelo111?.importe02)}</TableCell>
                                    <TableCell align="right" sx={numSx}>{fmtAmt(modelo111?.retenciones03)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Actividades económicas, dinerario (07-09)</TableCell>
                                    <TableCell align="right" sx={numSx}>{modelo111?.perceptores07}</TableCell>
                                    <TableCell align="right" sx={numSx}>{fmtAmt(modelo111?.importe08)}</TableCell>
                                    <TableCell align="right" sx={numSx}>{fmtAmt(modelo111?.retenciones09)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={3}>Total retenciones (28)</TableCell>
                                    <TableCell align="right" sx={numSx}>{fmtAmt(modelo111?.total28)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={3}>A deducir (29)</TableCell>
                                    <TableCell align="right" sx={numSx}>{fmtAmt(modelo111?.deducir29)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={3}><strong>Resultado a ingresar (30)</strong></TableCell>
                                    <TableCell align="right" sx={{...numSx, fontWeight: 600}}>{fmtAmt(modelo111?.resultado30)} €</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Box>
                    {(modelo111?.avisos?.length ?? 0) > 0 && (
                        <Alert severity="warning" sx={{mt: 2}}>
                            {modelo111.avisos.map((a: string, i: number) => <div key={i}>{a}</div>)}
                        </Alert>
                    )}
                </DialogContent>
                <DialogActions sx={{px: 3, pb: 2}}>
                    <Button size="small" variant="outlined" startIcon={<DownloadRoundedIcon/>}
                            onClick={() => exportModelo111Xls(modelo111)}>Descargar XLS</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={!!modelo190} onClose={() => setModelo190(null)} maxWidth="md" fullWidth PaperProps={{sx: {borderRadius: 3}}}>
                <DialogTitle sx={{fontWeight: 700}}>
                    Modelo 190 — Resumen anual IRPF {modelo190?.year}
                </DialogTitle>
                <DialogContent>
                    <Box mb={2}>
                        <Typography variant="body2" color="text.secondary">
                            Percepciones: <strong>{fmtAmt(modelo190?.totalPercepciones)} €</strong>
                            {" · "}
                            Retenciones: <strong>{fmtAmt(modelo190?.totalRetenciones)} €</strong>
                            {" · "}
                            Registros: <strong>{modelo190?.numPerceptores}</strong>
                            {" · "}
                            Suma de los 111: <strong>{fmtAmt(modelo190?.retenciones111)} €</strong>
                        </Typography>
                    </Box>
                    {(modelo190?.avisos?.length ?? 0) > 0 && (
                        <Alert severity="warning" sx={{mb: 2}}>
                            {modelo190.avisos.map((a: string, i: number) => <div key={i}>{a}</div>)}
                        </Alert>
                    )}
                    <Box sx={{overflowX: "auto", mb: 2}}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Clave</TableCell>
                                    <TableCell>Descripción</TableCell>
                                    <TableCell align="right">Perceptores</TableCell>
                                    <TableCell align="right">Percepciones</TableCell>
                                    <TableCell align="right">Retenciones</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(modelo190?.claves ?? []).map((c: any, i: number) => (
                                    <TableRow key={i}>
                                        <TableCell sx={numSx}>{c.clave}{c.subclave ? ` ${c.subclave}` : ""}</TableCell>
                                        <TableCell>{c.descripcion}</TableCell>
                                        <TableCell align="right" sx={numSx}>{c.perceptores}</TableCell>
                                        <TableCell align="right" sx={numSx}>{fmtAmt(c.percepcionIntegra)}</TableCell>
                                        <TableCell align="right" sx={numSx}>{fmtAmt(c.retenciones)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                    <Box sx={{overflowX: "auto"}}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>NIF</TableCell>
                                    <TableCell>Nombre</TableCell>
                                    <TableCell>Clave</TableCell>
                                    <TableCell align="right">Percepción íntegra</TableCell>
                                    <TableCell align="right">Retenciones</TableCell>
                                    <TableCell align="right">Documentos</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(modelo190?.perceptores ?? []).map((p: any, i: number) => (
                                    <TableRow key={i}>
                                        <TableCell sx={numSx}>{p.nif ?? "—"}</TableCell>
                                        <TableCell>{p.nombre}</TableCell>
                                        <TableCell sx={numSx}>{p.clave}{p.subclave ? ` ${p.subclave}` : ""}</TableCell>
                                        <TableCell align="right" sx={numSx}>{fmtAmt(p.percepcionIntegra)}</TableCell>
                                        <TableCell align="right" sx={numSx}>{fmtAmt(p.retenciones)}</TableCell>
                                        <TableCell align="right" sx={numSx}>{p.numDocumentos}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                </DialogContent>
                <DialogActions sx={{px: 3, pb: 2}}>
                    <Button size="small" variant="outlined" startIcon={<DownloadRoundedIcon/>}
                            onClick={() => exportModelo190Xls(modelo190)}>Descargar XLS</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={!!modelo390} onClose={() => setModelo390(null)} maxWidth="sm" fullWidth PaperProps={{sx: {borderRadius: 3}}}>
                <DialogTitle sx={{fontWeight: 700}}>
                    Modelo 390 — Resumen anual IVA {modelo390?.year}
                </DialogTitle>
                <DialogContent>
                    <Table size="small">
                        <TableBody>
                            <TableRow>
                                <TableCell><strong>Base imponible emitidas</strong></TableCell>
                                <TableCell align="right">{fmtAmt(modelo390?.baseEmitidas)} €</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Cuota IVA emitidas</strong></TableCell>
                                <TableCell align="right">{fmtAmt(modelo390?.vatEmitidas)} €</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Base imponible recibidas</strong></TableCell>
                                <TableCell align="right">{fmtAmt(modelo390?.baseRecibidas)} €</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Cuota IVA recibidas (deducible)</strong></TableCell>
                                <TableCell align="right">{fmtAmt(modelo390?.vatRecibidas)} €</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Resultado neto (a ingresar / a devolver)</strong></TableCell>
                                <TableCell align="right">
                                    <strong style={{color: (modelo390?.netResult ?? 0) < 0 ? "green" : "inherit"}}>
                                        {fmtAmt(modelo390?.netResult)} €
                                    </strong>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    {(modelo390?.avisos?.length ?? 0) > 0 && (
                        <Alert severity="warning" sx={{mt: 2}}>
                            {modelo390.avisos.map((a: string, i: number) => <div key={i}>{a}</div>)}
                        </Alert>
                    )}
                </DialogContent>
                <DialogActions sx={{px: 3, pb: 2}}>
                    <Button size="small" variant="outlined" startIcon={<DownloadRoundedIcon/>}
                            onClick={() => exportModelo390Xls(modelo390)}>Descargar XLS</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={!!modelo347} onClose={() => setModelo347(null)} maxWidth="lg" fullWidth PaperProps={{sx: {borderRadius: 3}}}>
                <DialogTitle sx={{fontWeight: 700}}>
                    Modelo 347 — Operaciones con terceros {modelo347?.year}
                    {modelo347?.threshold != null && (
                        <Typography variant="caption" sx={{ml: 1, color: "text.secondary"}}>
                            (umbral: {fmtAmt(Number(modelo347.threshold))} €)
                        </Typography>
                    )}
                </DialogTitle>
                <DialogContent>
                    {(modelo347?.errores?.length ?? 0) > 0 && (
                        <Alert severity="error" sx={{mb: 2}}>
                            <strong>No se puede presentar así.</strong>
                            {modelo347.errores.map((a: string, i: number) => <div key={i}>{a}</div>)}
                        </Alert>
                    )}
                    <Box mb={2}>
                        <Typography variant="body2" color="text.secondary">
                            Adquisiciones (A): <strong>{fmtAmt(modelo347?.totalAdquisiciones)} €</strong>
                            {" · "}
                            Entregas (B): <strong>{fmtAmt(modelo347?.totalEntregas)} €</strong>
                            {" · "}
                            Total: <strong>{fmtAmt(modelo347?.total)} €</strong>
                            {" · "}
                            Registros: <strong>{(modelo347?.lines ?? []).length}</strong>
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Un registro por NIF y clave; se declara el que supera el umbral. Importes con IVA.
                        </Typography>
                    </Box>
                    {/* #14729: a 390 px la tabla se desplaza en horizontal en vez de aplastarse */}
                    <TableContainer sx={{overflowX: "auto"}}>
                    <Table size="small" sx={{minWidth: 820}}>
                        <TableHead>
                            <TableRow>
                                <TableCell>NIF</TableCell>
                                <TableCell sx={{minWidth: 200}}>Nombre</TableCell>
                                <TableCell>Clave</TableCell>
                                <TableCell align="right">1T (€)</TableCell>
                                <TableCell align="right">2T (€)</TableCell>
                                <TableCell align="right">3T (€)</TableCell>
                                <TableCell align="right">4T (€)</TableCell>
                                <TableCell align="right">Anual (€)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(modelo347?.lines ?? []).map((l: any, i: number) => (
                                <TableRow key={i}>
                                    <TableCell sx={{fontFamily: "monospace", whiteSpace: "nowrap", color: l.nif ? undefined : "error.main"}}>
                                        {l.nif ?? "Sin NIF"}
                                    </TableCell>
                                    <TableCell>{l.nombre}</TableCell>
                                    <TableCell title={l.clave === "A" ? "Adquisiciones" : "Entregas"}>{l.clave}</TableCell>
                                    <TableCell align="right" sx={numSx}>{fmtAmt(l.importe1T)}</TableCell>
                                    <TableCell align="right" sx={numSx}>{fmtAmt(l.importe2T)}</TableCell>
                                    <TableCell align="right" sx={numSx}>{fmtAmt(l.importe3T)}</TableCell>
                                    <TableCell align="right" sx={numSx}>{fmtAmt(l.importe4T)}</TableCell>
                                    <TableCell align="right" sx={numSx}><strong>{fmtAmt(l.importeAnual)}</strong></TableCell>
                                </TableRow>
                            ))}
                            {(modelo347?.lines ?? []).length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={8} align="center">
                                        <Typography variant="body2" color="text.secondary">
                                            No hay terceros que superen el umbral configurado.
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    </TableContainer>
                    {(modelo347?.avisos?.length ?? 0) > 0 && (
                        <Alert severity="warning" sx={{mt: 2}}>
                            {modelo347.avisos.map((a: string, i: number) => <div key={i}>{a}</div>)}
                        </Alert>
                    )}
                </DialogContent>
                <DialogActions sx={{px: 3, pb: 2}}>
                    <Button size="small" variant="outlined" startIcon={<DownloadRoundedIcon/>}
                            onClick={() => exportModelo347Xls(modelo347)}>Descargar XLS</Button>
                </DialogActions>
            </Dialog>

            <Modelo200Dialog year={currentYear - 1} open={m200Open} onClose={() => setM200Open(false)}
                             onSaved={() => setTrigger(t => t + 1)}/>
            <Modelo202Dialog year={currentYear} open={m202Open} onClose={() => setM202Open(false)}
                             onSaved={() => setTrigger(t => t + 1)}/>

            <Dialog open={!!modelo115} onClose={() => setModelo115(null)} maxWidth="sm" fullWidth PaperProps={{sx: {borderRadius: 3}}}>
                <DialogTitle sx={{fontWeight: 700}}>
                    Modelo 115 — Retenciones alquileres {modelo115?.year} T{modelo115?.quarter}
                </DialogTitle>
                <DialogContent>
                    <Table size="small">
                        <TableBody>
                            <TableRow>
                                <TableCell><strong>Arrendadores (perceptores)</strong></TableCell>
                                <TableCell align="right">{modelo115?.numArrendadores}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Base imponible (alquileres)</strong></TableCell>
                                <TableCell align="right">{fmtAmt(modelo115?.baseImponible)} €</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Retención (19%)</strong></TableCell>
                                <TableCell align="right">{fmtAmt(modelo115?.retencion)} €</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>A ingresar</strong></TableCell>
                                <TableCell align="right">
                                    <strong>{fmtAmt(modelo115?.aIngresar)} €</strong>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    {(modelo115?.avisos?.length ?? 0) > 0 && (
                        <Alert severity="warning" sx={{mt: 2}}>
                            {modelo115.avisos.map((a: string, i: number) => <div key={i}>{a}</div>)}
                        </Alert>
                    )}
                </DialogContent>
                <DialogActions sx={{px: 3, pb: 2}}>
                    <Button size="small" variant="outlined" startIcon={<DownloadRoundedIcon/>}
                            onClick={() => exportModelo115Xls(modelo115)}>Descargar XLS</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={!!modelo180} onClose={() => setModelo180(null)} maxWidth="md" fullWidth PaperProps={{sx: {borderRadius: 3}}}>
                <DialogTitle sx={{fontWeight: 700}}>
                    Modelo 180 — Resumen anual alquileres {modelo180?.year}
                </DialogTitle>
                <DialogContent>
                    <Box mb={2}>
                        <Typography variant="body2" color="text.secondary">
                            Base total: <strong>{fmtAmt(modelo180?.totalBase)} €</strong>
                            {" · "}
                            Retención total: <strong>{fmtAmt(modelo180?.totalRetencion)} €</strong>
                            {" · "}
                            Arrendadores: <strong>{(modelo180?.lines ?? []).length}</strong>
                        </Typography>
                    </Box>
                    <TableContainer sx={{overflowX: "auto"}}><Table size="small" sx={{minWidth: 520}}>
                        <TableHead>
                            <TableRow>
                                <TableCell>NIF</TableCell>
                                <TableCell>Nombre</TableCell>
                                <TableCell align="right">Base imponible (€)</TableCell>
                                <TableCell align="right">Retención (€)</TableCell>
                                <TableCell align="right">Facturas</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(modelo180?.lines ?? []).map((l: any, i: number) => (
                                <TableRow key={i}>
                                    <TableCell sx={{fontFamily: "monospace"}}>{l.nif ?? "-"}</TableCell>
                                    <TableCell>{l.nombre}</TableCell>
                                    <TableCell align="right">{fmtAmt(l.baseImponible)}</TableCell>
                                    <TableCell align="right">{fmtAmt(l.retencion)}</TableCell>
                                    <TableCell align="right">{l.numFacturas}</TableCell>
                                </TableRow>
                            ))}
                            {(modelo180?.lines ?? []).length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        <Typography variant="body2" color="text.secondary">
                                            No hay facturas de alquiler con retención en este año.
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table></TableContainer>
                    {(modelo180?.avisos?.length ?? 0) > 0 && (
                        <Alert severity="warning" sx={{mt: 2}}>
                            {modelo180.avisos.map((a: string, i: number) => <div key={i}>{a}</div>)}
                        </Alert>
                    )}
                </DialogContent>
                <DialogActions sx={{px: 3, pb: 2}}>
                    <Button size="small" variant="outlined" startIcon={<DownloadRoundedIcon/>}
                            onClick={() => exportModelo180Xls(modelo180)}>Descargar XLS</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={!!modelo349} onClose={() => setModelo349(null)} maxWidth="lg" fullWidth PaperProps={{sx: {borderRadius: 3}}}>
                <DialogTitle sx={{fontWeight: 700}}>
                    Modelo 349 — Operaciones intracomunitarias {modelo349?.year} T{modelo349?.quarter}
                </DialogTitle>
                <DialogContent>
                    <Box mb={2}>
                        <Typography variant="body2" color="text.secondary">
                            Selector de período:{" "}
                            <select value={m349Year} onChange={e => setM349Year(Number(e.target.value))}
                                    style={{marginRight: 8}}>
                                {[currentYear - 2, currentYear - 1, currentYear].map(y => (
                                    <option key={y} value={y}>{y}</option>
                                ))}
                            </select>
                            <select value={m349Quarter} onChange={e => setM349Quarter(Number(e.target.value))}>
                                <option value={1}>T1</option>
                                <option value={2}>T2</option>
                                <option value={3}>T3</option>
                                <option value={4}>T4</option>
                            </select>
                        </Typography>
                        {modelo349 && (
                            <Typography variant="body2" color="text.secondary" mt={1}>
                                Entregas y prestaciones (E, S): <strong>{fmtAmt(modelo349?.totalEntregas)} €</strong>
                                {" · "}
                                Adquisiciones (A, I): <strong>{fmtAmt(modelo349?.totalAdquisiciones)} €</strong>
                                {" · "}
                                Operadores declarados: <strong>{(modelo349?.lines ?? []).length}</strong>
                            </Typography>
                        )}
                    </Box>
                    <Box sx={{overflowX: "auto"}}>
                        <Table size="small" sx={{minWidth: 560}}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>NIF Intracomunitario</TableCell>
                                    <TableCell>Nombre</TableCell>
                                    <TableCell>Clave</TableCell>
                                    <TableCell align="right">Base imponible (€)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(modelo349?.lines ?? []).map((l: any, i: number) => (
                                    <TableRow key={i}>
                                        <TableCell sx={{fontFamily: "monospace"}}>{l.vatEu ?? "-"}</TableCell>
                                        <TableCell>{l.nombre}</TableCell>
                                        <TableCell>
                                            <strong>{l.claveOperacion}</strong>
                                            {" — "}
                                            {l.claveOperacion === "E" ? "Entrega de bienes"
                                                : l.claveOperacion === "A" ? "Adquisición de bienes"
                                                : l.claveOperacion === "S" ? "Prestación de servicios"
                                                : l.claveOperacion === "I" ? "Adquisición de servicios"
                                                : l.claveOperacion}
                                        </TableCell>
                                        <TableCell align="right">{fmtAmt(l.baseImponible)}</TableCell>
                                    </TableRow>
                                ))}
                                {(modelo349?.lines ?? []).length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">
                                            <Typography variant="body2" color="text.secondary">
                                                No hay operaciones intracomunitarias en el periodo seleccionado.
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Box>
                    {(modelo349?.avisos?.length ?? 0) > 0 && (
                        <Alert severity="warning" sx={{mt: 2}}>
                            {modelo349.avisos.map((a: string, i: number) => <div key={i}>{a}</div>)}
                        </Alert>
                    )}
                </DialogContent>
                <DialogActions sx={{px: 3, pb: 2}}>
                    <Button size="small" variant="outlined" startIcon={<DownloadRoundedIcon/>}
                            onClick={() => exportModelo349Xls(modelo349)}>Descargar XLS</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
